'use_strict';

import $ from 'jquery';
import 'intl-tel-input';

const intlTelInput = {

  /**
   * Initialize tel input.
   *
   * @param {string} selector HTML element query selector.
   * @param {object} options Input options.
   * @param {boolean} [options.validate=true] Whether default validation logic is used. Default is true.
   * @param {boolean} [options.useInternationalNumber=true] Whether input value is set to internationational format during form submit. Default is true.
   */
  init: function(selector, options = {}) {
    options = {
      validate: true,
      useInternationalNumber: true,
      ...options
    };
    selector = selector || 'input.validateTel';

    var country = $(document.body).data('language');

    // match document language to initial country selection
    if(country && country.indexOf('_') !== -1) {
      country = country.split('_')[1];
    }

    country = country ? country.toLowerCase() : '';

    if(country === 'sv' ) {
      country = 'se';
    } else if(country === 'en') {
      country = 'gb';
    }

    // init plugin
    $(selector).each(function() {
      var $this = $(this);
      var thisCountry = $this.attr('data-language');
      var thisPreferred = $this.attr('data-preferred');

      if(thisCountry) {
        thisCountry = thisCountry.split('_').pop().toLowerCase();
      }

      if(thisPreferred) {
        thisPreferred = $this.attr('data-preferred').split(',');
      }

      $this.intlTelInput({
        utilsScript: window.assetBaseUrl + 'web/dist/js/intlTelInput/utils.js',
        initialCountry: (thisCountry || country),
        preferredCountries: thisPreferred || ['us', 'gb'], // preferred countries show at top of the list
        customPlaceholder: function() {
          return '';
        }
      });
    });

    const updateCountryListWidth = () => {
      const input = $(selector);
      input.closest('.intl-tel-input').find('.country-list').width(input.outerWidth());
    };
    if (selector !== 'input.validateTel') {
      updateCountryListWidth();
      $(window).on('resize', updateCountryListWidth);
    }

    // validate form + set number value in international format
    // Note: there can be multiple forms with tel fields on same page
    if (options.useInternationalNumber) {
      $(selector).parents('form').on('submit', function() {
        const form = this;
        const telInputs = $(selector, form);

        let validForm = Array.from(telInputs).every(input => !input.classList.contains('stage-error'));

        if(!validForm) {
          return false;
        }

        telInputs.each(function(index, input) {
          $(input).val($(input).intlTelInput('getNumber'));
        });

        return true;
      });
    }

    // attach events to validation
    if (options.validate) {
      $(selector).on('blur focusout keyup',function(e){
        var error = $(this).intlTelInput('getValidationError'),
          label =  $(this).parents('label'),
          errorClass = 'stage-error'; // not 'error' nor 'form-error' nor 'stage-form-error'. No. It's 'stage-error'

        if( error ){
          console.log(error);
          console.log(window.intlTelInputUtils?.validationError);
        }

        if( error === 0 || $(this).val() === ''){
          $(this).toggleClass(errorClass,false).toggleClass('error',false);
          label.removeAttr('title');
        }
        else if (error === -99) {
          // Can happen if utils script fails to load
          $(this).toggleClass(errorClass,true).toggleClass('error',true);
          label.attr('title', 'Failed to validate number');
        }
        else if( error === window.intlTelInputUtils.validationError.TOO_SHORT ){
          $(this).toggleClass(errorClass,true).toggleClass('error',true);
          label.attr('title','Number too short');
        }
        else if( error === window.intlTelInputUtils.validationError.INVALID_COUNTRY_CODE ){
          $(this).toggleClass(errorClass,true).toggleClass('error',true);
          label.attr('title','Invalid country code');
        }
        else if( error === window.intlTelInputUtils.validationError.TOO_LONG ){
          $(this).toggleClass(errorClass,true).toggleClass('error',true);
          label.attr('title','Number too long');
        }
        else if( error === window.intlTelInputUtils.validationError.NOT_A_NUMBER ){
          $(this).toggleClass(errorClass,true).toggleClass('error',true);
          label.attr('title','Not a number');
        }
      });

      // attach events to validation
      $(selector).on('focusout',function(e){
        if (!this.classList.contains('stage-error')) {
          $(this).val($(this).intlTelInput('getNumber'));
        }
      });
    }
  }

};

export default intlTelInput;
